import { useContext } from "react";
import { useMutation, useQueryClient } from "react-query";
import { AuthContext } from "../../Context/AuthContext";

const acceptPackage = async (packageId, token) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_SERVER_URL}/packages/acceptpackage-driver/${packageId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to accept package");
    }

    return response.json();
  } catch (error) {
    throw new Error(error.message);
  }
};

const useAcceptPackage = () => {
  const { token } = useContext(AuthContext);
  const queryClient = useQueryClient();

  return useMutation((packageId) => acceptPackage(packageId, token), {
    onSuccess: () => {
      queryClient.invalidateQueries("driverAssignment");
    },
  });
};

export default useAcceptPackage;

